<div
    class="gap-medpace border-color-border border border-solid p-d-medpace rounded-medpace relative mt-medpace flex flex-col"
>
    <div class="flex flex-1 justify-between">
        <h5>Expense {{ index() + 1 }}</h5>
        <mds-icon-button
            [icon]="'delete'"
            (clickEvent)="removeExpense()"
            [tooltip]="'Delete'"
            class="danger outline"
        ></mds-icon-button>
    </div>
    <mds-dropdown
        [closeOnPageScroll]="false"
        appearance="outline"
        label="Expense Type"
        placeholder="Select expense type"
        [options]="(availableExpensesOptions$ | async) ?? []"
        id="expensesDropdown"
        [attr.data-cy]="'expenseTypeDropdown'"
        [formCtrl]="formGrp().controls.type"
    />
    @let isMileageExpense = isMileageExpense$ | async;
    @if (isMileageExpense === true) {
        <medpace-mileage-expense-edit
            [expense]="expense()"
            [index]="index()"
            [expenseFormGroup]="formGrp()"
            [formGrp]="formGrp().controls.mileageExpense"
        />
    } @else {
        <medpace-other-expense-edit
            [expense]="expense()"
            [index]="index()"
            [expenseFormGroup]="formGrp()"
            [formGrp]="formGrp().controls.otherExpense"
        />
    }
    @let elevatedAccess = elevatedAccess$ | async;
    @let isInProcessOrHigher = requestService.isInProcessOrHigher$ | async;
    @if (isInProcessOrHigher === true && elevatedAccess === true) {
        <mds-textarea
            id="notes-field"
            [formCtrl]="formGrp().controls.notes"
            [label]="'Notes'"
            [appearance]="'outline'"
            [placeholder]="'Type here...'"
            [autoSize]="true"
            [cdkAutosizeMinRows]="4"
            [cdkAutosizeMaxRows]="8"
        />
    }
</div>
